import React from 'react';
import {Route, Switch, withRouter} from "react-router-dom";

import ResetPasswordForm from "./ResetPasswordForm";
import ForgottenPasswordForm from "./ForgottenPasswordForm";

import './style.css';

class ForgottenPassword extends React.Component {
    render() {
        return (
            <div className="login-wrapper">
                <div className="animate form login-form">
                    <section className="login-content">
                        <Switch>
                            <Route exact path="/ForgottenPassword" component={() => <ForgottenPasswordForm {...this.props}/>}/>
                            <Route path="/ForgottenPassword/reset/:resetToken" component={() => <ResetPasswordForm {...this.props}/>}/>
                        </Switch>
                    </section>
                </div>
            </div>
        );
    }
}

export default withRouter(ForgottenPassword);


/** WEBPACK FOOTER **
 ** ./src/containers/ForgottenPassword/index.js
 **/